exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-tags-input[data-v-1d94502c]{max-width:1000px;font-size:14px;font-weight:400!important}", ""]);

// exports
